<template>

    <TemplateBasic 
      v-bind:breadcrumb="breadcrumb"
      v-bind:permission="permission">

      <div 
        v-for="(row, rowIndex) in content"
        v-bind:key="rowIndex">
          <div class="row">
          <label class="control-label text-left text-xl-right col-sm-3 col-md-3 col-lg-3 col-xl-2" v-html="row.title + ': '"></label>
          <div class="col"><p class="form-control-static" v-html="row.text || '-'"></p></div>
          </div>
      </div>

      <AppTable 
        ref="pageTable" 
        v-bind:tableParameter="PARAM"
        v-on:table-data-click="onTableDataClick" 
        v-on:table-page-change="onTablePageChange" />

      <TemplateFeedback class="m-t" ref="pageFeedback" />

    </TemplateBasic>

</template>

<script>
import TemplateBasic from "@/components/Template/TemplateBasic";
import TemplateButton from "@/components/Template/TemplateButton";
import TemplateFeedback from "@/components/Template/TemplateFeedback";
import AppSearch from "@/components/App/AppSearch";
import AppPaging from "@/components/App/AppPaging";
import AppFilter from "@/components/App/AppFilter";
import AppTable from "@/components/App/AppTable";
import AppAddButton from "@/components/App/AppAddButton";
import AppForm from "@/components/App/AppForm";
import AppModalForm from "@/components/App/AppModalForm";
import validation from "@/components/Utility/Validation"
import helper from "@/components/Utility/Helper"
import iPayPaymentCode from "@/components/Param/iPayPaymentCode"

import PageBillCollectionSelect from "@/components/Page/Collection/PageBillCollectionSelect"


let invoiceNumTableCustom = function(dataResult, dataIndex, dataParameter, parameterIndex) {
  let parameterItem = dataParameter[parameterIndex];
  let dataItem = dataResult[dataIndex];
  if(dataItem['jt-summary']) return;
  
  let billNum = helper.plBillNum(dataItem.creditNum || dataItem.debitNum || dataItem.invoiceNum, dataItem.carparkID, dataItem['type']);
  return `<a href="billPage?invoiceID=${dataItem.invoiceID}&type=${dataItem._type}" target="_blank">${billNum}</a>`;
  // return `<a href="${dataItem.path}" target="_blank">${billNum}</a>`;
};
let invoiceAmountTableCustom = function(dataResult, dataIndex, dataParameter, parameterIndex) {
  let parameterItem = dataParameter[parameterIndex];
  let dataItem = dataResult[dataIndex];
  return helper.formatMoney(dataItem[parameterItem.key]);
};

var querystring = require('querystring');
const PARAM = [
  {
    key: '_index',
    index: true,
  },
  {
    key: '_licenseNum',
    text: 'Parking License',
    table_custom: function(dataResult, dataIndex, dataParameter, parameterIndex) {
      let parameterItem = dataParameter[parameterIndex];
      let dataItem = dataResult[dataIndex];
      if(dataItem['jt-summary']) return;

      if(!dataItem['licenseID']) {
        return;
      }
      if(dataItem['_licenseStatus'] === 'Pending' || dataItem['_licenseStatus'] === 'Pending Initial Payment' || dataItem['_licenseStatus'] === 'Terminated') {
        return helper.plFormPLNum(dataItem._licenseNum, dataItem._carparkNum);
      }
      return `<a target="_blank" href="${helper.WEB_URL}/parkinglicenseView?licenseID=${dataItem.licenseID}">${helper.plFormPLNum(dataItem._licenseNum, dataItem._carparkNum)}</a>`;
    },
  },
  {
    key: '_billDate',
    text: 'Bill Date',
    table_custom: function(dataResult, dataIndex, dataParameter, parameterIndex) {
      let parameterItem = dataParameter[parameterIndex];
      let dataItem = dataResult[dataIndex];
      if(dataItem['jt-summary']) return;

      if(dataItem['_dataRef'] && dataItem['_dataRef']['billingDate']) {
        let billingDate = helper.parseDateTime(dataItem['_dataRef']['billingDate']);
        if(billingDate) {
          return billingDate.format('DD/MM/YYYY');
        }
      }

      return '';
    }
  },
  {
    key: '_billType',
    text: 'Bill Type',
    table_custom: function(dataResult, dataIndex, dataParameter, parameterIndex) {
      let parameterItem = dataParameter[parameterIndex];
      let dataItem = dataResult[dataIndex];
      if(dataItem['jt-summary']) return;

      if(dataItem['type'].endsWith('INV')) {
        return 'Invoice';
      } else if(dataItem['type'].endsWith('DN')) {
        return 'Debit Note';
      } else if(dataItem['type'].endsWith('CN')) {
        return 'Credit Note';
      }

      return '';
    }
  },
  {
    key: '_customerAccount',
    text: 'Bill No.',
    table_custom: function(dataResult, dataIndex, dataParameter, parameterIndex) {
      let parameterItem = dataParameter[parameterIndex];
      let dataItem = dataResult[dataIndex];
      if(dataItem['jt-summary']) return;

      let billNum = helper.plBillNum(dataItem.creditNum || dataItem.debitNum || dataItem.invoiceNum, dataItem.carparkID, dataItem['type']);
      return `<a href="billPage?invoiceID=${dataItem.invoiceID}&type=${dataItem._type}" target="_blank">${billNum}</a>`;
    },
  },
  {
    key: 'status',
    text: 'Description',
    table_custom: function(dataResult, dataIndex, dataParameter, parameterIndex) {
      let parameterItem = dataParameter[parameterIndex];
      let dataItem = dataResult[dataIndex];
      if(dataItem['jt-summary']) return;

      if(dataItem['_dataRef'] && dataItem['_dataRef']['description']) {
        return dataItem['_dataRef']['description'];
      }

      return '';
    }
  },
  {
    key: '_amount',
    text: 'Amount (RM)',
    table_custom: function(dataResult, dataIndex, dataParameter, parameterIndex) {
      let parameterItem = dataParameter[parameterIndex];
      let dataItem = dataResult[dataIndex];

      let text = helper.formatMoney(dataItem['price']);
      if(!dataItem['jt-summary'] && dataItem['type'].endsWith('CN')) {
        text = '-' + text;
      }
      return text;
      
    }
  },
];

export default {
  name: "PagePaymentDetail",
  components: {
    TemplateBasic,
    TemplateButton,
    AppSearch,
    AppPaging,
    AppFilter,
    AppTable,
    AppAddButton,
    AppForm,
    AppModalForm,
    TemplateFeedback,
  },
  data () {
    return {
      permission : null,
      breadcrumb : [
        { name: 'Home', url: helper.WEB_URL },
        { name: 'Bill Collection' },
        { name: 'Transaction' },
        { name: 'Payment History' },
      ],

      PARAM,
      content: [],
    }
  },
  mounted() {
    if(!helper.hasViewPermission(this.permission = helper.getPermission(this))) {
      return;
    }

    this.$refs['pageTable'].getTableIdentifier = () => 'invoiceID';
    this.loadCollection();
  },
  methods: {
    loadCollection() {
      let collectionID = this.$route.query.collectionID;
      if(!collectionID) return;

      let feedbackItem = 'collection data';
      this.$refs['pageFeedback'].setFeedbackLoading('Loading ' + feedbackItem);

      this.$http
        .get(
          helper.SERVER_URL + '/api2/collection/' + collectionID,
          helper.createAxiosConfig()
        )
        .then(response => {
          let resultMeta = helper.processAxiosResponse(this, response);
          this.pageCollection = response.data;

          if(!this.pageCollection || this.pageCollection.length === 0) {
            this.$refs['pageFeedback'].setFeedbackError('Problem loading collection data');
            return;
          }

          this.$refs['pageFeedback'].setFeedbackMessage();
          this.loadCarpark();
        })
        .catch(error => {
          this.$refs['pageFeedback'].setFeedbackError(helper.parseAxiosErrorMessage(this, error, 'loading', feedbackItem));
        });
    },
    loadCarpark() {
      let feedbackItem = 'car park data';
      this.$refs['pageFeedback'].setFeedbackLoading('Loading ' + feedbackItem);

      this.$http
        .get(
          helper.SERVER_URL + '/api2/carpark/' + this.pageCollection[0].carparkID,
          helper.createAxiosConfig()
        )
        .then(response => {
          let resultMeta = helper.processAxiosResponse(this, response);
          this.pageCarpark = response.data;
          this.$refs['pageFeedback'].setFeedbackMessage();
          this.loadCustomer();
        })
        .catch(error => {
          this.$refs['pageFeedback'].setFeedbackError(helper.parseAxiosErrorMessage(this, error, 'loading', feedbackItem));
        });
    },
    loadCustomer() {
      let feedbackItem = 'customer data';
      this.$refs['pageFeedback'].setFeedbackLoading('Loading ' + feedbackItem);

      this.$http
        .get(
          helper.SERVER_URL + '/api2/customer/' + this.pageCollection[0].customerID,
          helper.createAxiosConfig()
        )
        .then(response => {
          let resultMeta = helper.processAxiosResponse(this, response);
          this.$refs['pageFeedback'].setFeedbackMessage();
          this.pageCustomer = response.data;
          this.loadLicense();
        })
        .catch(error => {
          this.$refs['pageFeedback'].setFeedbackError(helper.parseAxiosErrorMessage(this, error, 'loading', feedbackItem));
        });
    },
    loadLicense() {
      let feedbackItem = 'license data';
      this.$refs['pageFeedback'].setFeedbackLoading('Loading ' + feedbackItem);

      let url = helper.SERVER_URL + '/api2';
      url += '/license?carparkID=' + this.pageCollection[0].carparkID + '&customerID=' + this.pageCollection[0].customerID;

      this.$http
        .get(
          url,
          helper.createAxiosConfig()
        )
        .then(response => {
          let resultMeta = helper.processAxiosResponse(this, response);
          this.pageLicense = response.data;
          response.data.forEach(k => {
            k['_customer'] = this.pageCustomer.find(j => j.id === k.customerID);
            k['_carpark'] = this.pageCarpark.find(j => j.id === k.carparkID);
          });
          this.$refs['pageFeedback'].setFeedbackMessage();

          if(response.data && response.data.length > 0) {
            this.loadFundDetail();
          } else {
            this.$refs['pageFeedback'].setFeedbackError('Problem loading ' + feedbackItem);
          }
        })
        .catch(error => {
          this.$refs['pageFeedback'].setFeedbackError(helper.parseAxiosErrorMessage(this, error, 'loading', feedbackItem));
        });
    },
    // loadStaff() {
    //   let feedbackItem = 'staff data';
    //   this.$refs['pageFeedback'].setFeedbackLoading('Loading ' + feedbackItem);

    //   let url = helper.SERVER_URL + '/api2/personnel';
    //   this.$http
    //     .get(
    //       url,
    //       helper.createAxiosConfig()
    //     )
    //     .then(response => {
    //       let resultMeta = helper.processAxiosResponse(this, response);
    //       this.pageStaff = response.data;
    //       this.$refs['pageFeedback'].setFeedbackMessage();

    //       this.loadFundDetail();
    //     })
    //     .catch(error => {
    //       this.$refs['pageFeedback'].setFeedbackError(helper.parseAxiosErrorMessage(this, error, 'loading', feedbackItem));
    //     });
    // },
    loadFundDetail() {
      if(!this.pageCollection[0].paymentType || this.pageCollection[0].paymentType === '-') {
        this.pageFund = {};
        this.displayData();
        return;
      }

      let feedbackItem = 'fund data';
      this.$refs['pageFeedback'].setFeedbackLoading('Loading ' + feedbackItem);
      let paymentType = this.pageCollection[0].paymentType;
      if(paymentType === 'Cheque') {
        paymentType = 'check'
      }
      let url = helper.SERVER_URL + '/api2/fund/' + paymentType + '?RefNo=' + this.pageCollection[0].id;
      this.$http
        .get(
          url,
          helper.createAxiosConfig()
        )
        .then(response => {
          let resultMeta = helper.processAxiosResponse(this, response);
          this.pageFund = response.data;
          this.$refs['pageFeedback'].setFeedbackMessage();
          
          if(response.data && response.data.length > 0) {
            this.pageFund = response.data.find(k => helper.compareID(k.RefNo, this.pageCollection[0].id));
            if(this.pageFund) {
              this.displayData();
            } else {
              this.$refs['pageFeedback'].setFeedbackError('Problem loading ' + feedbackItem);
            }
          } else {
            this.$refs['pageFeedback'].setFeedbackError('Problem loading ' + feedbackItem);
          }
        })
        .catch(error => {
          this.$refs['pageFeedback'].setFeedbackError(helper.parseAxiosErrorMessage(this, error, 'loading', feedbackItem));
        });
    },
    displayData() {
      let temp = [];
      let total = 0;
      this.pageCollection.forEach(k => {
        let type = k['type'];
        if(type.endsWith('INV')) {
          k['_type'] = 'invoice';
          total += k['price'];
        } else if(type.endsWith('CN')) {
          k['_type'] = 'creditNote';
          total -= k['price'];
        } else if(type.endsWith('DN')) {
          k['_type'] = 'debitNote';
          total += k['price'];
        }

        try {
          k['_dataRef'] = JSON.parse(k['data']);
        } catch(e) {              
        }

        k['_license'] = this.pageLicense.find(j => j.carparkID === k.carparkID && j.customerID === k.customerID);
        k['licenseID'] = k['_license']['id'];
        k['_licenseStatus'] = k['_license']['status'];
        k['_licenseNum'] = k['_license']['licenseOperatorNum'];
        k['_carparkNum'] = k['_license']['carparkID'];
        k['_carpark'] = this.pageCarpark.find(j => j.id === k['carparkID']) || {};
        k['_carparkName'] = (k['_carpark'] || {}).name;
        k['_customer'] = this.pageCustomer.find(j => j.id === k['customerID']) || {};
        k['_customerType'] = (k['_customer'] || {}).isCompany ? 'Company' : 'Personal';

        // let collectionID = k['id'];
        // temp[collectionID] = temp[collectionID] || k;
        // temp[collectionID]._invoice = temp[collectionID]._invoice || [];
        // temp[collectionID]._invoice.push(k);
      });
      this.pageCollection.push({'jt-summary': true, price: total});

      let sample = this.pageCollection[0];
      let content = this.content;
      let paymentMethod = sample['paymentType'];

      // let staff = this.pageStaff.find(k => k.id === this.pageFund.personnelID) || {};
      let paymentType = sample['paymentType'];
      if(paymentType === 'Cheque') {
        paymentType = 'check'
      }

      if(paymentType.toLowerCase() === 'cash') {
        content.push({ title: 'Payment Method', text: helper.convertPaymentMethod(paymentMethod) });
        content.push({ title: 'Staff Name', text: this.pageFund.staffName || '' });
        content.push({ title: 'Staff No.', text: this.pageFund.personnelCode || '' });
      } else if(paymentType.toLowerCase() === 'check') {
        content.push({ title: 'Payment Method', text: helper.convertPaymentMethod(paymentMethod) });
        content.push({ title: 'Cheque Bank Code', text: this.pageFund.BankCode });
        content.push({ title: 'Cheque Bank Name', text: this.pageFund.BankName });
        content.push({ title: 'Cheque Number', text: this.pageFund.ChequeNumber });
        content.push({ title: 'Cheque Date', text: helper.formatDateTime(this.pageFund.ChequeDate) });
        content.push({ title: 'Staff Name', text: this.pageFund.staffName || '' });
        content.push({ title: 'Staff No.', text: this.pageFund.personnelCode || '' });
      } else if(paymentType.toLowerCase() === 'giro') {
        content.push({ title: 'Payment Method', text: helper.convertPaymentMethod(paymentMethod) });
        content.push({ title: 'GIRO Ref Number', text: this.pageFund.Code });
        content.push({ title: 'GIRO Date', text: helper.formatDate(this.pageFund.GiroDate) });
        // content.push({ title: 'GIRO Date', text: this.pageFund.Code });
        content.push({ title: 'Staff Name', text: this.pageFund.staffName || '' });
        content.push({ title: 'Staff No.', text: this.pageFund.personnelCode || '' });
      } else if(paymentType.toLowerCase() === 'online') {
        let hasDefinedPaymentMethod = false;
        if(this.pageFund['PaymentId']) {
          let paymentMethod = iPayPaymentCode.find(k => helper.compareID(k.paymentId, this.pageFund['PaymentId']));
          if(paymentMethod && paymentMethod.paymentMethod) {
            content.push({ title: 'Payment Method', text: paymentMethod.paymentMethod });
            hasDefinedPaymentMethod = true;
          }
        }

        if(!hasDefinedPaymentMethod) {
          content.push({ title: 'Payment Method', text: paymentMethod });
        }
        content.push({ title: 'Transaction ID', text: sample['ref'] });
        // content.push({ title: 'Authentication Code', text: '' });
      }

      // this.pageCollection = Object.keys(temp).map(k => temp[k]);
      this.$refs['pageTable'].setTableData(this.pageCollection);
    },

    onFilterCarparkChange(dataIndex) {
      this.$refs['pageTable'].setCurrentPage(1);
      this.$refs['pageTable'].setTableData(null);
      this.loadLicense();
    },
    onFilterLicenseChange(dataIndex) {
      this.$refs['pageTable'].setCurrentPage(1);
      this.$refs['pageTable'].setTableData(null);
      this.loadData();
    },
    onTablePageChange() {
      this.loadData();
    },
    onSearchChange(dataIndex) {
      this.$refs['pageTable'].setCurrentPage(1);
      this.loadData();
    },

    onAddButtonClick() {
    },
    onTableDataClick(tableData, tableDataIndex) {
    },

    onFormInput(formData, formParameter, input) {
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/components/Page/Collection/PagePaymentDetail.vue